import { MenuItem, FormControl, InputLabel } from "@mui/material";
import { useEffect, useState } from "react";
import StyledTextField from "../text-field/styled-text-field";

interface FormFieldSelectProps {
  defaultValue: string;
  labelValue: string;
  selectValues: string[];
  onSelectChange: (value: string) => void;
}
const INPUT_HEIGHT = 48;

const FormFieldSelect = ({
  defaultValue,
  labelValue,
  selectValues,
  onSelectChange,
}: FormFieldSelectProps) => {
  const [selectedValue, setSelectedValue] = useState<string>(defaultValue);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedValue(e.target.value);
    onSelectChange(e.target.value);
  };

  useEffect(() => {
    setSelectedValue(defaultValue);
  }, [defaultValue]);

  return (
    <FormControl fullWidth variant="standard">
      <InputLabel
        shrink
        htmlFor={`${labelValue}-input`}
        data-testid={`form-field-select-label-${labelValue}`}
        sx={{
          position: "relative",
          marginBottom: "2px",
          fontWeight: 500,
          fontSize: "0.95rem",
          color: "text.primary",
        }}
      >
        {labelValue}
      </InputLabel>
      <StyledTextField
        id={`select-${labelValue}-input`}
        data-testid={`form-field-select-${labelValue}`}
        height={INPUT_HEIGHT}
        value={selectedValue}
        select
        variant="outlined"
        size="medium"
        onChange={handleChange}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: 2,
            transition: "all 0.2s ease",
            "&:hover": {
              "& .MuiOutlinedInput-notchedOutline": {
                borderColor: "primary.main",
              },
            },
            "&.Mui-focused": {
              "& .MuiOutlinedInput-notchedOutline": {
                borderWidth: 2,
              },
            },
          },
        }}
      >
        {selectValues.map((itemValue) => (
          <MenuItem
            key={`select-menu-item-${itemValue}`}
            value={itemValue}
            data-testid={`select-menu-item-${itemValue}`}
          >
            {itemValue}
          </MenuItem>
        ))}
      </StyledTextField>
    </FormControl>
  );
};

export default FormFieldSelect;
